import { useMemo } from 'react'

import { Scope } from '../../../enums/scope'
import { useScopedFeatureAccess } from '../../../hooks/useScopedFeatureAccess'

export const useInvoiceMultiCurrencyAccess = () => {
  const { isLockedByUpsell, shouldShowFeature } = useScopedFeatureAccess(
    Scope.InvoiceMultiCurrency,
    Scope.InvoiceMultiCurrencyUpsell,
  )

  return useMemo(
    () => ({
      isInvoiceMultiCurrencyLockedByUpsell: isLockedByUpsell,
      shouldDisplayInvoiceMultiCurrency: shouldShowFeature,
    }),
    [isLockedByUpsell, shouldShowFeature],
  )
}
